<template>
  <template v-if="type == 'info:eu-repo/semantics/book'">
    <Book
      :sourcePath="sourcePath"
      :authors="authors"
      :title="title"
      :dateIssued="dateIssued"
      :publisher="publisher"
      :doi="doi"
    />
  </template>
  <template v-else-if="type == 'info:eu-repo/semantics/article'">
    <JournalArticle
      :sourcePath="sourcePath"
      :authors="authors"
      :title="title"
      :dateIssued="dateIssued"
      :journal="journal"
      :doi="doi"
    />
  </template>
  <template
    v-else-if="
      [
        'info:eu-repo/semantics/doctoralThesis',
        'info:eu-repo/semantics/masterThesis',
        'info:eu-repo/semantics/bachelorThesis'
      ].includes(type)
    "
  >
    <Thesis
      :sourcePath="sourcePath"
      :authors="authors"
      :title="title"
      :dateIssued="dateIssued"
      :degree="degree"
      :grantor="grantor"
      :doi="doi"
    />
  </template>
  <template v-else>
    <JournalArticle
      :sourcePath="sourcePath"
      :authors="authors"
      :title="title"
      :dateIssued="dateIssued"
      :journal="journal"
      :doi="doi"
    />
  </template>
</template>
<script>
import Book from "@/components/ui/objects/APAFormat/Book";
import JournalArticle from "@/components/ui/objects/APAFormat/JournalArticle";
import Thesis from "@/components/ui/objects/APAFormat/Thesis";

export default {
  components: {
    Book,
    JournalArticle,
    Thesis
  },
  props: {
    format: {
      type: String,
      default: "APA",
      validator(value) {
        /* According to OpenAIRE Guidelines */
        return ["APA", "ISO", "default"].includes(value);
      }
    },
    orderNumber: {
      type: Number,
      default: 0
    },
    type: {
      type: String,
      default: "info:eu-repo/semantics/other",
      validator(value) {
        /* According to ALICIA 2.0.1 Guidelines: http://repositorio.concytec.gob.pe/bitstream/20.500.12390/2231/1/VERSI%C3%93N%20FINAL%20-%20GUIA%20ALICIA%202.0.1%20-%20ENERO%202021.pdf */
        return [
          "info:eu-repo/semantics/article",
          "info:eu-repo/semantics/doctoralThesis",
          "info:eu-repo/semantics/masterThesis",
          "info:eu-repo/semantics/bachelorThesis",
          "info:eu-repo/semantics/report",
          "info:eu-repo/semantics/book",
          "info:eu-repo/semantics/bookPart",
          "info:eu-repo/semantics/conferenceObject",
          "info:eu-repo/semantics/contributionToPeriodical",
          "info:eu-repo/semantics/lecture",
          "info:eu-repo/semantics/monograph",
          "info:eu-repo/semantics/other",
          "info:eu-repo/semantics/patent",
          "info:eu-repo/semantics/review",
          "info:eu-repo/semantics/technicalDocumentation",
          "info:eu-repo/semantics/workingPaper",
          "info:pe-repo/semantics/datase",
          "info:pe-repo/semantics/software",
          "info:pe-repo/semantics/video",
          "info:pe-repo/semantics/sound",
          "info:pe-repo/semantics/stillImag",
          "info:eu-repo/semantics/other"
        ].includes(value);
      }
    },
    sourcePath: {
      type: String
    },
    thumbnailPath: {
      type: String
    },
    title: {
      type: String,
      default: "No title"
    },
    authors: {
      type: Array,
      default: () => []
    },
    dateIssued: {
      type: String
    },
    publisher: {
      type: String
    },
    journal: {
      type: String
    },
    abstract: {
      type: String
    },
    doi: {
      type: String
    },
    degree: {
      type: String
    },
    grantor: {
      type: String
    }
  }
};
</script>
<style lang="scss" scoped>
@use "@/assets/styles/settings/_variables.scss";
article {
  padding-left: 1.5em;
  text-indent: -1.5em;
  margin-bottom: 1.5em;
}
</style>
